import dashboardBundleService from '@/services/dashboard/event_dashboard_bundle'

function normalizeDateTime(dateValue, timeValue) {
  if (!dateValue) {
    return null
  }

  const datePart = String(dateValue).substring(0, 10)
  const timePart = timeValue ? String(timeValue).substring(0, 8) : '00:00:00'
  const parsed = new Date(`${datePart}T${timePart}`)
  return Number.isNaN(parsed.getTime()) ? null : parsed
}

function formatDateTime(dateValue, timeValue) {
  const parsed = normalizeDateTime(dateValue, timeValue)
  if (!parsed) {
    return ''
  }

  const dd = `${parsed.getDate()}`.padStart(2, '0')
  const mm = `${parsed.getMonth() + 1}`.padStart(2, '0')
  const yyyy = parsed.getFullYear()
  const hh = `${parsed.getHours()}`.padStart(2, '0')
  const min = `${parsed.getMinutes()}`.padStart(2, '0')

  return `${dd}/${mm}/${yyyy} ${hh}:${min}`
}

function pickNextScheduled(items) {
  const candidates = (items || []).filter(item => ['scheduled', 'queued', 'executing'].includes((item.status || '').toLowerCase()))

  if (!candidates.length) {
    return null
  }

  return candidates
    .slice()
    .sort((a, b) => {
      const aDate = normalizeDateTime(a.scheduled_date, a.scheduled_time)
      const bDate = normalizeDateTime(b.scheduled_date, b.scheduled_time)

      if (!aDate && !bDate) return 0
      if (!aDate) return 1
      if (!bDate) return -1
      return aDate.getTime() - bDate.getTime()
    })[0]
}

export default {
  async get(eventId, options = {}) {
    const empty = {
      totalGuests: 0,
      confirmed: 0,
      pending: 0,
      declined: 0,
      withoutTable: 0,
      nextScheduledDisplay: 'Sin envios programados',
      nextScheduledRaw: null
    }

    if (!eventId) {
      return empty
    }

    try {
      const bundle = await dashboardBundleService.get(eventId, options)
      const metrics = bundle.metrics || {}
      const guests = bundle.guests || []
      const schedules = bundle.schedules || []

      const activeGuests = guests.filter(g => Number(g.is_confirm || 0) !== 2)
      const withoutTable = activeGuests.filter(g => Number(g.event_table_id || 0) <= 0).length

      const nextScheduled = pickNextScheduled(schedules)
      const nextScheduledDisplay = nextScheduled
        ? formatDateTime(nextScheduled.scheduled_date, nextScheduled.scheduled_time)
        : 'Sin envios programados'

      return {
        totalGuests: Number(metrics.total || 0),
        confirmed: Number(metrics.confirm || 0),
        pending: Number(metrics.pending || 0),
        declined: Number(metrics.canceled || 0),
        withoutTable,
        nextScheduledDisplay,
        nextScheduledRaw: nextScheduled
      }
    } catch (error) {
      return empty
    }
  },

  invalidate(eventId) {
    dashboardBundleService.invalidate(eventId)
  }
}
